import type {AutomatedSuggestion, SuggestionDiffLine, ThreadComment} from './types'
// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-imports
import type {StaticDiffLine} from '@github-ui/diff-lines/conversation-types'

function escapeHtml(text: string): string {
  return text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
}

/**
 * Converts a `SuggestionDiffLine` to the `StaticDiffLine` shape expected by
 * `StaticUnifiedDiffPreview`. The only field that needs synthesising is `html`,
 * which is produced by HTML-escaping the plain `text`.
 */
export function toStaticDiffLine(line: SuggestionDiffLine): StaticDiffLine {
  return {
    type: line.type as StaticDiffLine['type'],
    text: line.text,
    html: escapeHtml(line.text),
    left: line.left,
    right: line.right,
  }
}

/**
 * Resolves structured suggestion data on a ThreadComment so the dialog knows
 * to render it with a React diff component. Returns the comment unchanged when
 * suggestion data is already present or unavailable.
 */
export function resolveThreadCommentSuggestion(tc: ThreadComment): ThreadComment {
  if (!tc.suggestion || tc.suggestionState !== 'present') return tc
  return {...tc, hasSuggestion: true}
}

export function buildThreadCommentsFromSuggestion(
  message: string,
  permalink: string,
  suggestion: AutomatedSuggestion | undefined,
  suggestionState: string | undefined,
): ThreadComment[] {
  const hasSuggestion = suggestionState === 'present' && !!suggestion
  const filename = suggestion?.diffEntries?.[0]?.path ?? ''

  return [
    {
      filename,
      message,
      permalink,
      hasSuggestion,
      ...(hasSuggestion ? {suggestion, suggestionState} : {}),
    },
  ]
}
